var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('BarChart',{ref:"chart",attrs:{"title":"","labels":_vm.labels,"values":_vm.values}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }